// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"7ccbddc9","453":"676ca6bf"}[chunkId] + ".chunk.js";
};